import React from 'react';
import { Button } from 'primereact/button';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import useFilterBreakpoint from 'hooks/useFilterBreakpoint';

import CaseFilter from './CaseFilter';
import FileTypeFilter from './FileTypeFilter';
import TagFilter from './TagFilter';
import FileStatusFilter from './FileStatusFilter';
import ReadStatusFilter from './ReadStatusFilter';
import ResetFilters from './ResetFilters';

const Filters = () => {
  const { isClientFileManager, isCaseFileManager, isLeadFileManager, isFirmDocuments } = useFileManagerContext();
  const { showFilters, setShowFilters } = useFilterBreakpoint();

  return (
    <>
      <div className="d-block d-lg-none w-100">
        <Button
          className="p-button p-component btn p-button-secondary outline w-100 filter-toggle-btn"
          type="button"
          onClick={() => setShowFilters((v) => !v)}
          aria-expanded={showFilters}
          aria-controls="file-filter-section"
          label="Filters"
        >
          <span
            style={{
              fontSize: 18,
              transition: 'transform 0.2s',
              display: 'inline-block',
              transform: showFilters ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          >
            <i className="fa fa-solid fa-angle-down"></i>
          </span>
        </Button>
      </div>
      <div
        className={`d-flex flex-wrap align-items-center gap-2 filter-toggle-section filter-section${showFilters ? ' show' : ''}`}
        id="file-filter-section"
        aria-hidden={!showFilters}
      >
        <label className="text-bold black-600  me-2 filter-label">Filters:</label>

        {isClientFileManager && <CaseFilter />}
        <FileTypeFilter />
        <TagFilter />
        {(isCaseFileManager || isClientFileManager || isLeadFileManager) && <FileStatusFilter />}
        {isFirmDocuments && <ReadStatusFilter />}
        <ResetFilters />
      </div>
    </>
  );
};

export default Filters;
